import { Container, Rectangle } from 'pixi.js';
import { PixiViewportSystem } from 'yage/systems/render/PixiViewport';
import type { ReadOnlyGameModel } from 'yage/game/GameModel';
import { LOCAL } from '../services/local.js';
import { state, ids } from '../services/world.js';
import { Transform } from 'yage/schemas/entity/Transform';
import { AirportPlane } from '../components/index.js';
import { localPlayer } from '../services/local.js';
import { C, label, rounded } from './primitives.js';

export class DepartureMoment {
    readonly root = new Container();
    private flights: number | null = null;
    private hideAt = 0;
    private width = 0;
    private height = 0;
    constructor(parent: Container) { parent.addChild(this.root); this.root.zIndex = 900; this.root.visible = false; this.root.eventMode = 'static'; this.root.on('pointerdown', event => event.stopPropagation()); this.root.on('pointertap', () => this.dismiss()); }
    resize(w: number, h: number) { this.width = w; this.height = h; if (this.root.visible) { this.render(); this.paint(); } }
    update(g: ReadOnlyGameModel) {
        const count = state(g).flights;
        if (this.flights === 0 && count === 1) {
            // The payoff is watching it leave: no pause, the camera rides along with the takeoff.
            this.root.visible = true;
            this.hideAt = g.frame + 330;
            const plane = ids(g, AirportPlane).find(id => g.getTypedUnsafe(AirportPlane, id).phase === 1), captain = localPlayer(g);
            if (plane !== undefined && captain >= 0 && !LOCAL.reducedMotion) {
                const p = g.getTypedUnsafe(Transform, captain);
                LOCAL.cinematic = { entity: plane, until: g.frame + 300, captain, origin: { x: p.x, y: p.y } };
            }
            this.render();
            this.paint();
        }
        if (this.root.visible && g.frame >= this.hideAt) this.dismiss();
        this.flights = count;
    }
    private render() {
        this.root.removeChildren().forEach(child => child.destroy({ children: true }));
        const w = Math.min(380, this.width - 24), x = (this.width - w) / 2, y = this.width < 700 ? 146 : 100;
        this.root.hitArea = new Rectangle(x, y, w, 92);
        rounded(this.root, x, y, w, 92, 16, C.cream);
        label(this.root, '✈ FIRST DEPARTURE!', x + 18, y + 14, 24, C.navy, '900', w - 36);
        label(this.root, 'Your passengers are on their way. Keep the terminal busy for the next one!', x + 18, y + 50, 13, C.muted, '600', w - 36);
    }
    private dismiss() {
        if (!this.root.visible) return;
        this.root.visible = false;
        this.paint();
    }
    private paint() {
        const app = LOCAL.model?.getSystem(PixiViewportSystem)?.pixiApp;
        if (app) app.renderer.render(app.stage);
    }
    destroy() { this.dismiss(); this.root.destroy({ children: true }); }
}
